<script setup>
import { RouterView } from 'vue-router';
import 'bootstrap'; 

</script>
 
<template>
  <div id="app">
    <RouterView />
  </div>
</template>
<style>
html,
body,
#app {
  height: 100vh;
  overflow: hidden;
}

body {
  margin: 0;
}
</style>
 
 